<!--操作结果或者异常状态做反馈-->
<template>
  <div class="my-result-body">
    <el-result :icon="icon" :title="title" :subTitle="subTitle">
      <template slot="extra">
        <slot></slot>
      </template>
    </el-result>
  </div>
</template>

<script>
export default {
  name: 'MyResult',
  props: ['icon', 'title', 'subTitle']
}
</script>

<style scoped>
.el-result {
  width: 350px;
  background-color: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 1%;
}
.my-result-body {
  background-color: rgba(0,0,0,.5);
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
